import { defineAction } from '~/prix'
import migrationCreateAction from './migrationCreate.action.json' with { type: 'json' }
import { z } from 'zod'

const migrationCreateDefinition = defineAction({
  ...migrationCreateAction,

  input: z
    .object({
      olap: z.boolean().optional(),
      oltp: z.boolean().optional(),
      database: z.enum(['olap', 'oltp']).optional(),
      sql: z.boolean().optional(),
      js: z.boolean().optional(),
      ts: z.boolean().optional(),
      type: z.enum(['ts', 'js', 'sql']).optional(),
    })
    .refine(
      data => {
        // Validação 1: Pelo menos um de olap, oltp ou database deve ser especificado
        const { olap, oltp, database } = data
        return olap || oltp || database
      },
      {
        message:
          'You must specify one of olap, oltp or database. Example: migration-create --olap --sql (database: OLAP, type: SQL)',
      },
    )
    .refine(
      data => {
        // Validação 2: Apenas um de olap, oltp ou database pode ser especificado
        const { olap, oltp, database } = data
        const specified = [olap, oltp, database !== undefined].filter(Boolean)
        return specified.length <= 1
      },
      {
        message:
          'You can only specify one of olap or oltp. Example: migration-create --olap --sql (database: OLAP, type: SQL)',
      },
    )
    .refine(
      data => {
        // Validação 3: Pelo menos um de sql, js, ts ou type deve ser especificado
        const { sql, js, ts, type } = data
        return sql || js || ts || type
      },
      {
        message:
          'You must specify one of sql, js, ts. Example: migration-create --olap --sql (database: OLAP, type: SQL)',
      },
    )
    .refine(
      data => {
        // Validação 4: Apenas um de sql, js, ts ou type pode ser especificado
        const { sql, js, ts, type } = data
        const specified = [sql, js, ts, type !== undefined].filter(Boolean)
        return specified.length <= 1
      },
      {
        message:
          'You can only specify one of sql, js or ts. Example: migration-create --olap --sql (database: OLAP, type: SQL)',
      },
    ),
  output: z.object({}),
})

export default migrationCreateDefinition
